
import { defineComponent, onMounted, computed, ref } from "vue";

import {
  HomeSectionTiles,
  GameCard,
  LayoutFooter,
  NewsCard,
} from "@/components";

import { VIASAT_AD_ENDPOINT } from "@/services/advertisements"

import { useI18n } from "vue-i18n";
import getEnv from "@/utils/env";
import { useStore, ActionTypes, AdvertisementSpots } from "@/store";

export default defineComponent({
  data() {
    return {
      adSpotTop: AdvertisementSpots.HomeTop,
      adSpotFooter: AdvertisementSpots.HomeFooter,
      adSpotMiddle: AdvertisementSpots.HomeMiddle,
      hideShop: getEnv("VUE_APP_DISABLE_SHOP"),
    };
  },
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "global",
    });

    const store = useStore();

    const trendingGame = computed(() => store.getters.trendingGame);
    const trendingShop = computed(() => store.getters.trendingShop);
    const trendingNews = computed(() => store.getters.trendingNews);

    let pageReady = ref(false);

    onMounted(async () => {
          await store.dispatch(ActionTypes.GetViasatFlightData);

          if (store.getters.viasatFlightData != undefined) {
            const script = document.createElement('script');
            script.type = 'module';
            script.innerHTML = `
            import AdUnit from '${VIASAT_AD_ENDPOINT}interstitial/v1/index.js';
            AdUnit({
                containerId: "ad-unit-home",
                count: 3,
                destination: "${store.getters.viasatFlightData?.destination}",
                flightId: "${store.getters.viasatFlightData?.flightId}",
                flightNumber: "${store.getters.viasatFlightData?.flightNumber}",
                locale: "en-US",
                origin: "${store.getters.viasatFlightData?.origin}",
                placementTag: "interstitial_1",
                vehicleId: "${store.getters.viasatFlightData?.vehicleId}",
                venue: "VIA",
                timeout: 5000,
                identifiers: {
                    DEVICE_ID: "TestIfcDeviceGuidOk",
                },
            });
          `;
            document.body.appendChild(script);
          }

          Promise.all([
            store.dispatch(ActionTypes.GetTrendingGame),
            store.dispatch(ActionTypes.GetTrendingShop),
            store.dispatch(ActionTypes.GetTrendingNews),
          ]).then(() => {
            pageReady.value = true;
          })
        }
    );

    return {
      t,
      trendingGame,
      trendingShop,
      trendingNews,
      pageReady,
    };
  },
  components: {
    GameCard,
    HomeSectionTiles,
    NewsCard,
    LayoutFooter,
  },
});
